export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8645.7dedaa10.jpg";